import { render, staticRenderFns } from "./categoryItem.vue?vue&type=template&id=591ffeb2&"
import script from "./categoryItem.vue?vue&type=script&lang=js&"
export * from "./categoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports